import React from 'react';

interface DataContext {
  items: Array<{
    internal: {
      type: string;
    }
  }>;
  addtitonalData?: any;
  metaData?: any;
}

export default function Paragraphs(args: DataContext): React.JSX.Element {
  return (
    <>
      {args.items.map((item, index) => {
        const parts = item.internal?.type.replace('paragraph__', '').split('_');
        if (!parts || 0 == parts.length) return null;

        const componentName = parts?.map(part => {
          return part.charAt(0).toUpperCase() + part.slice(1);
        }).join('');

        const Component = require(`./${componentName}.tsx`).default;

        return (
          <Component
            key={index}
            drupalData={item}
            additionalData={args.addtitonalData}
            metaData={args.metaData}
          />
        );
      })}
    </>
  );
}
